// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/acumin-rpro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/acumin-rpro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/acumin-itpro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/acumin-itpro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/acumin-bdpro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/acumin-bdpro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/acumin-bditpro.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/acumin-bditpro.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/IBMPlexMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/IBMPlexMono-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/images/GenZLandingPageWallpaper.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/reaction_images/mind360.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Acumin-RPro";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Acumin-ItPro";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Acumin-BdPro";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Acumin-BdItPro";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "IBM Plex Mono";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: "Acumin-RPro", sans-serif;
}

canvas {
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

/* App.css (partial) */
nav ul {
  list-style-type: none;
  padding: 0;
  display: flex;
  justify-content: center;
}

nav li {
  margin: 10px;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.landing-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: center;
  background-color: transparent;
  font-family: "Acumin-RPro", sans-serif;
  padding: 20px;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%; /* Header causes height to increase to 110%? */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: center;
  opacity: 0.2;
}

.logo {
  width: 300px;
  margin-bottom: 20px;
}

.textLogo {
  width: 484px;
  margin: -290px -200px -200px -200px;
}

.apply {
  text-decoration: none;
  margin-bottom: 20px;
  font-size: 14px;
  color: #000;
  font-family: "Acumin-BdPro", sans-serif;
}

.highlight {
  color: #ff2a2f;
  text-decoration: underline;
}

.centered-text {
  text-align: center;
  max-width: 80%;
  margin-bottom: 20px;
  font-size: 18px;
  color: #000;
  font-family: "Acumin-BdPro", sans-serif;
}

.centered-text-2 {
  text-align: center;
  max-width: 80%;
  margin-bottom: 20px;
  font-size: 20px;
  color: #000;
  font-family: "Acumin-BdPro", sans-serif;
}

.smallCentered-text {
  text-align: center;
  max-width: 80%;
  font-size: 14px;
  margin: -5px 0px 0px 0px;
  color: #000;
}

.skip-link {
  font-family: "Acumin-RPro", sans-serif;
  text-decoration: none;
  color: #888888;
}

/* Container for the entire sign-up section */
.signup-container {
  font-family: "Acumin-RPro", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distributes space between items */
  align-items: center; /* Centers items horizontally */
  height: 100vh; /* Full height of the viewport */
  padding: 20px; /* Adds some padding around the container */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.9;
  z-index: -1;
}

@media only screen and (max-width: 768px) {
  .title-signup {
    margin-bottom: 2px;
    font-size: 30px;
  }
  .signup-input {
    margin-bottom: 2px;
  }
}

/* Style for the back arrow */
.arrow-button {
  align-self: flex-start; /* Aligns the back arrow to the start (left) */
  margin-top: 20px; /* Margin at the top */
  margin-left: 15px; /* Margin on the left */
}

/* Style for the back arrow image */
.arrow {
  width: 30px; /* Adjust size as needed */
  height: auto;
  font-weight: bolder;
  color: #000;
}

/* Title style for SignUp Page */
.title-signup {
  margin-bottom: 80px;
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 30px;
  font-weight: 900;
  z-index: 100;
}

.signup-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  margin-bottom: 30px;
}

/* Style for the input field */
.input-field {
  padding: 15px;
  border-radius: 10px;
  width: 300px;
  margin-top: -100px;
  margin-bottom: 10px;
  border: none;
  background-color: #f1f1f1;
  font-size: 16px;
  font-family: "Acumin-RPro", sans-serif;
}

/* Style for the input field when focused */
.input-field:focus {
  outline: 2px solid #ff2a2f;
}
.input-fields {
  padding: 15px;
  border-radius: 10px;
  width: 300px;
  margin-top: -15rem;
  border: none;
  background-color: #f1f1f1;
  font-size: 16px;
  font-family: "Acumin-RPro", sans-serif;
}

.input-field-password {
  padding: 15px;
  border-radius: 10px;
  width: 300px;
  margin-top: -15rem;
  border: none;
  background-color: #f1f1f1;
  font-size: 16px;
  font-family: "Acumin-RPro", sans-serif;
}

.toggle-password-button {
  position: absolute;
  transform: translateX(-150%);
  background: none;
  border: none;
  cursor: pointer;
}

.password-input-container {
  position: relative;
}

/* Style for the sign-up button */
.button {
  width: 100%;
  max-width: 200px;
  height: 100%;
  max-height: 60px;
  padding: 10px 0;
  margin-bottom: 120px;
  border-radius: 10px;
  font-size: 18px;
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
}

/* Style for the sign-up button */
.complete-feed-button {
  width: 100%;
  max-width: 200px;
  height: 100%;
  max-height: 60px;
  padding: 10px 0;
  margin-bottom: 120px;
  border-radius: 10px;
  font-size: 18px;
  text-align: center;
  background-color: #ff2a2f;
  color: #ffffff;
  border: none;
  font-family: "Acumin-BdPro", sans-serif;
}

/* Style for the button with red background */
.red-background {
  background-color: #ff2a2f;
  color: #ffffff;
  border: none;
  font-family: "Acumin-RPro", sans-serif;
}

/* Style for the button with grey background */
.grey-background {
  background-color: #eaebeb;
  color: #afacac;
  border: none;
  font-family: "Acumin-BdPro", sans-serif;
}

/* Title style for Phone Verification */
.title-verification {
  margin-top: -10px;
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 20px;
}

.title-verification2 {
  margin-top: -10px;
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 20px;
}

.phoneVerificationInstructions {
  align-items: center;
  margin-top: -30px;
  font-size: 16px;
  justify-content: center;
  font-family: "Acumin-RPro", sans-serif;
}

.code-input {
  padding: 5px;
  border-radius: 10px;
  width: 30px;
  height: 35px;
  margin: 10px 5px;
  background-color: #f1f1f1;
  font-size: 16px;
  font-family: "Acumin-RPro", sans-serif;
  border: none;
  text-align: center;
}

.code-input:focus {
  outline: 2px solid #ff2a2f;
}

.error {
  color: #ff2a2f;
  font-size: 12px;
  font-family: "Acumin-RPro", sans-serif;
}

.error-container {
  margin-top: -20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.error-container2 {
  margin-top: -20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
}

.resend-code {
  font-size: 14px;
  align-items: center;
  justify-content: center;
  font-family: "Acumin-RPro", sans-serif;
  text-decoration: underline;
}

.resend-refresh {
  font-size: 14px;
  align-items: center;
  justify-content: center;
  font-family: "Acumin-RPro", sans-serif;
}

.title-gender {
  margin-bottom: 20px;
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 20px;
}

.description-text {
  width: 100%;
  max-width: 500px;
  margin: 0 auto 10px;
  text-align: left;
  padding-left: 10px;
  color: #808080;
}

.gender-description-text {
  width: 100%;
  max-width: 500px;
  margin: 0 auto 10px;
  text-align: left;
  padding-left: 5px;
  color: #808080;
}

.gender-input-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
  background: #f1f1f1;

  margin-left: 0.5rem;
  cursor: pointer;
  padding: 9px 12px 9px 12px;
}

.gender-input-container label {
  width: 100%;
  text-align: left;
  margin-right: auto;
  cursor: pointer;
  align-items: center;
}

.gender-input-container input[type="radio"] {
  accent-color: #ff2a2f;
}

.gender-input-container:focus-within {
  outline: 2px solid #808080;
}
.date-input-container {
  position: relative; /* Allows absolute positioning inside */
  width: 100%; /* Adjust as needed */
  max-width: 300px; /* Adjust as needed */
}

/* Style for the input field */
.date-input-field {
  padding: 10px;
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: -60px;
  margin-bottom: 0px;
  padding-right: 30px;
  border: none;
  background-color: #f1f1f1;
  font-size: 20px;
  font-family: "Acumin-RPro", sans-serif;
  color: #000;
  text-align: left;
}

.date-input-icon {
  position: absolute;
  top: 15px;
  right: 10px; /* Adjust as needed */
  transform: translateY(-50%); /* Centers the icon vertically */
  height: 20px; /* Adjust as needed */
  width: 20px; /* Adjust as needed */
  pointer-events: none; /* Makes the icon non-interactive */
}

.date-error-container {
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.select-interests-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: "Acumin-RPro", sans-serif;
}

.select-interest-button {
  padding: 10px;
  border-radius: 30px;
  width: 45%;
  margin: 5px;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pink-background {
  background-color: #f6dada;
  color: #000000;
  border: none;
  font-family: "Acumin-RPro", sans-serif;
}

.normal-background {
  background-color: #f2f2f2;
  color: #000000;
  pointer-events: auto;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  border: none;
  font-family: "Acumin-RPro", sans-serif;
}

.interest-description-text {
  font-size: 16px;
  text-align: center;
  color: #393939;
}

.interests-button-container {
  display: flex;
  justify-content: center;
}

.columns-interests {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.title-interests {
  text-align: center;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 20px;
}

.profile-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.ProfilePicture_Sub-Text {
  width: 100%;
  max-width: 300px;
  margin: 0 auto 10px;
  text-align: center;
  padding-left: 10px;
  color: #808080;
  font-size: small;
}

.image-box {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  background-color: #eaeaea;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}

.upload-box {
  display: flex;
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */
  width: 150px; /* Same width as image-box */
  height: 150px; /* Same height as image-box */
  border-radius: 10px; /* Same border radius as image-box */
  background-color: #eaeaea; /* Same background color as image-box */
  margin-bottom: 20px; /* Same bottom margin as image-box */
  color: #666; /* Text color, can be adjusted */
  font-size: 14px; /* Text size, can be adjusted */
  cursor: pointer; /* Changes the cursor to indicate it's clickable */
  text-align: center; /* Ensures text is centered */
}

.image-box2 {
  width: 250px;
  height: 250px;
  border-radius: 20px;
  background-color: #eaeaea;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom: 10px;
}

.upload-box2 {
  display: flex;
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */
  width: 250px; /* Same width as image-box */
  height: 250px; /* Same height as image-box */
  border-radius: 20px; /* Same border radius as image-box */
  background-color: #eaeaea; /* Same background color as image-box */
  margin-bottom: 10px; /* Same bottom margin as image-box */
  color: #666; /* Text color, can be adjusted */
  font-size: 14px; /* Text size, can be adjusted */
  cursor: pointer; /* Changes the cursor to indicate it's clickable */
  text-align: center; /* Ensures text is centered */
}

.Optional {
  width: 100%;
  max-width: 300px;
  text-align: center;
  color: #808080;
  font-size: small;
  margin-bottom: -5rem;
}

.profile-image {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.file-input {
  display: none;
}

.signup2-container {
  font-family: "Acumin-RPro", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers items horizontally */
  height: 100vh; /* Full height of the viewport */
  padding: 20px; /* Adds some padding around the container */
}

.paypal-vemo-logo {
  width: 32px;
}

.payment-button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-button {
  display: flex;
  width: 371px;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  margin: 10px 0;
  font-size: 20px;
  border: none;
  cursor: pointer;
  background-color: rgba(241, 241, 241, 0.658);
  color: #000000;
  font-family: "Acumin-RPro", sans-serif;
  transition: background-color 0.3s;
}

.payment-button-hovered {
  background-color: rgba(208, 208, 208, 0.658);
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: auto;
}

.termstitle {
  display: flex;
  flex-direction: column;
  margin-bottom: 5vh;
}

.Terms {
  display: flex;
  flex-direction: column;
  margin-left: 0rem;
  align-items: start;
}

.title-verification3 {
  text-decoration: none;
  color: black;
  margin-top: -10px;
  text-align: left;
  font-family: "Acumin-BdPro", sans-serif;
  font-size: 20px;
  margin-left: 0.2rem;
  align-self: first baseline;
}

.custom-link {
  color: #ff2a2f;
  text-decoration: none;
}

#custom-link:hover {
  text-decoration: underline;
}

.Conditions {
  margin-top: -rem;
  display: flex;
  flex-direction: column;
  max-width: 500px;
}

.Condition {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 3rem;
}

.Condition label {
  text-align: left;
  font-size: larger;
}

.Message {
  margin-left: 5rem;
  margin-top: -2.5rem;
}

.Conditions input[type="checkbox"] {
  display: none;
}

.custom-checkbox {
  width: 40px;
  height: 40px;
  background-color: #eee;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

input[type="checkbox"]:checked + .custom-checkbox::before {
  content: "\\2713";
}

input[type="checkbox"]:checked + .custom-checkbox {
  background-color: #ff2a2f;
  content: "\\2713";
  color: black;
}

.footer-logo img {
  margin-left: 4px;
  height: 40px; /* Adjust as per your logo's dimensions */
}

.quiz-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.quiz-container p {
  margin-bottom: 10px;
}

.quiz-container strong {
  font-weight: bold;
  color: #333;
}

.quiz-container p strong {
  margin-right: 5px;
}

.quiz-container p:last-child {
  margin-bottom: 0;
}

.quiz-container-ol {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.quiz-container-ol-choice:hover {
  /* Your styles for hover state */
  background-color: #f0f0f0;
  transition: ease-in-out 0.2s;
  cursor: pointer;
}

@media screen and (max-width: 200px) {
  .fixed-footer {
    /* Mobile-specific styles here */
  }

  .footer-content {
    flex-direction: column;
  }
}

.USA-HEADER {
  width: 280px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.asset-brandName {
  margin-left: 5px;
  color: blue;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B;;0DAEuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;;0DAEwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;;0DAEwD;EACxD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B;;0DAE0D;EAC1D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;;0DAE+D;EAC/D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0DAAqE;EACrE,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY,EAAE,8CAA8C;EAC5D,0DAAqE;EACrE,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,oCAAoC;EACpE,mBAAmB,EAAE,+BAA+B;EACpD,aAAa,EAAE,gCAAgC;EAC/C,aAAa,EAAE,2CAA2C;EAC1D,0DAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAGlB,eAAe;EAFjB;EAIA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;EACE,sBAAsB,EAAE,8CAA8C;EACtE,gBAAgB,EAAE,sBAAsB;EACxC,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA,mCAAmC;AACnC;EACE,WAAW,EAAE,0BAA0B;EACvC,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,uCAAuC;AACzC;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sCAAsC;AACxC;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,uCAAuC;AACzC;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;;EAEnB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB,EAAE,uCAAuC;EAC3D,WAAW,EAAE,qBAAqB;EAClC,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE,qBAAqB;EAClC,2BAA2B,EAAE,gCAAgC;EAC7D,YAAY,EAAE,qBAAqB;EACnC,WAAW,EAAE,qBAAqB;EAClC,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,YAAY,EAAE,4BAA4B;EAC1C,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB,EAAE,oCAAoC;EACzD,yBAAyB,EAAE,uCAAuC;EAClE,mBAAmB,EAAE,oCAAoC;EACzD,WAAW,EAAE,gCAAgC;EAC7C,eAAe,EAAE,+BAA+B;EAChD,eAAe,EAAE,kDAAkD;EACnE,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,YAAY,EAAE,4BAA4B;EAC1C,aAAa,EAAE,6BAA6B;EAC5C,mBAAmB,EAAE,oCAAoC;EACzD,yBAAyB,EAAE,uCAAuC;EAClE,mBAAmB,EAAE,oCAAoC;EACzD,WAAW,EAAE,gCAAgC;EAC7C,eAAe,EAAE,+BAA+B;EAChD,eAAe,EAAE,kDAAkD;EACnE,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,+BAA+B;EACpD,aAAa,EAAE,gCAAgC;EAC/C,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,cAAc;EACd,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY,EAAE,yCAAyC;AACzD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["@font-face {\n  font-family: \"Acumin-RPro\";\n  src:\n    url(\"./assets/fonts/acumin-rpro.woff2\") format(\"woff2\"),\n    url(\"./assets/fonts/acumin-rpro.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Acumin-ItPro\";\n  src:\n    url(\"./assets/fonts/acumin-itpro.woff2\") format(\"woff2\"),\n    url(\"./assets/fonts/acumin-itpro.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Acumin-BdPro\";\n  src:\n    url(\"./assets/fonts/acumin-bdpro.woff2\") format(\"woff2\"),\n    url(\"./assets/fonts/acumin-bdpro.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Acumin-BdItPro\";\n  src:\n    url(\"./assets/fonts/acumin-bditpro.woff2\") format(\"woff2\"),\n    url(\"./assets/fonts/acumin-bditpro.woff\") format(\"woff\");\n  font-weight: bold;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"IBM Plex Mono\";\n  src:\n    url(\"./assets/fonts/IBMPlexMono-Regular.woff2\") format(\"woff2\"),\n    url(\"./assets/fonts/IBMPlexMono-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\nbody {\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\ncanvas {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n/* App.css (partial) */\nnav ul {\n  list-style-type: none;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n}\n\nnav li {\n  margin: 10px;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.landing-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-image: url(\"./assets/images/GenZLandingPageWallpaper.svg\");\n  background-size: cover;\n  background-position: center;\n  background-color: transparent;\n  font-family: \"Acumin-RPro\", sans-serif;\n  padding: 20px;\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 110%; /* Header causes height to increase to 110%? */\n  background-image: url(\"./assets/images/GenZLandingPageWallpaper.svg\");\n  background-size: cover;\n  background-position: center;\n  opacity: 0.2;\n}\n\n.logo {\n  width: 300px;\n  margin-bottom: 20px;\n}\n\n.textLogo {\n  width: 484px;\n  margin: -290px -200px -200px -200px;\n}\n\n.apply {\n  text-decoration: none;\n  margin-bottom: 20px;\n  font-size: 14px;\n  color: #000;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n.highlight {\n  color: #ff2a2f;\n  text-decoration: underline;\n}\n\n.centered-text {\n  text-align: center;\n  max-width: 80%;\n  margin-bottom: 20px;\n  font-size: 18px;\n  color: #000;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n.centered-text-2 {\n  text-align: center;\n  max-width: 80%;\n  margin-bottom: 20px;\n  font-size: 20px;\n  color: #000;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n.smallCentered-text {\n  text-align: center;\n  max-width: 80%;\n  font-size: 14px;\n  margin: -5px 0px 0px 0px;\n  color: #000;\n}\n\n.skip-link {\n  font-family: \"Acumin-RPro\", sans-serif;\n  text-decoration: none;\n  color: #888888;\n}\n\n/* Container for the entire sign-up section */\n.signup-container {\n  font-family: \"Acumin-RPro\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Distributes space between items */\n  align-items: center; /* Centers items horizontally */\n  height: 100vh; /* Full height of the viewport */\n  padding: 20px; /* Adds some padding around the container */\n  background-image: url(\"./assets/reaction_images/mind360.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  opacity: 0.9;\n  z-index: -1;\n}\n\n@media only screen and (max-width: 768px) {\n  .title-signup {\n    margin-bottom: 2px;\n  }\n  .title-signup {\n    font-size: 30px;\n  }\n  .signup-input {\n    margin-bottom: 2px;\n  }\n}\n\n/* Style for the back arrow */\n.arrow-button {\n  align-self: flex-start; /* Aligns the back arrow to the start (left) */\n  margin-top: 20px; /* Margin at the top */\n  margin-left: 15px; /* Margin on the left */\n}\n\n/* Style for the back arrow image */\n.arrow {\n  width: 30px; /* Adjust size as needed */\n  height: auto;\n  font-weight: bolder;\n  color: #000;\n}\n\n/* Title style for SignUp Page */\n.title-signup {\n  margin-bottom: 80px;\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 30px;\n  font-weight: 900;\n  z-index: 100;\n}\n\n.signup-input {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 100px;\n  margin-bottom: 30px;\n}\n\n/* Style for the input field */\n.input-field {\n  padding: 15px;\n  border-radius: 10px;\n  width: 300px;\n  margin-top: -100px;\n  margin-bottom: 10px;\n  border: none;\n  background-color: #f1f1f1;\n  font-size: 16px;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n/* Style for the input field when focused */\n.input-field:focus {\n  outline: 2px solid #ff2a2f;\n}\n.input-fields {\n  padding: 15px;\n  border-radius: 10px;\n  width: 300px;\n  margin-top: -15rem;\n  border: none;\n  background-color: #f1f1f1;\n  font-size: 16px;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.input-field-password {\n  padding: 15px;\n  border-radius: 10px;\n  width: 300px;\n  margin-top: -15rem;\n  border: none;\n  background-color: #f1f1f1;\n  font-size: 16px;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.toggle-password-button {\n  position: absolute;\n  transform: translateX(-150%);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.password-input-container {\n  position: relative;\n}\n\n/* Style for the sign-up button */\n.button {\n  width: 100%;\n  max-width: 200px;\n  height: 100%;\n  max-height: 60px;\n  padding: 10px 0;\n  margin-bottom: 120px;\n  border-radius: 10px;\n  font-size: 18px;\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n/* Style for the sign-up button */\n.complete-feed-button {\n  width: 100%;\n  max-width: 200px;\n  height: 100%;\n  max-height: 60px;\n  padding: 10px 0;\n  margin-bottom: 120px;\n  border-radius: 10px;\n  font-size: 18px;\n  text-align: center;\n  background-color: #ff2a2f;\n  color: #ffffff;\n  border: none;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n/* Style for the button with red background */\n.red-background {\n  background-color: #ff2a2f;\n  color: #ffffff;\n  border: none;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n/* Style for the button with grey background */\n.grey-background {\n  background-color: #eaebeb;\n  color: #afacac;\n  border: none;\n  font-family: \"Acumin-BdPro\", sans-serif;\n}\n\n/* Title style for Phone Verification */\n.title-verification {\n  margin-top: -10px;\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 20px;\n}\n\n.title-verification2 {\n  margin-top: -10px;\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 20px;\n}\n\n.phoneVerificationInstructions {\n  align-items: center;\n  margin-top: -30px;\n  font-size: 16px;\n  justify-content: center;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.code-input {\n  padding: 5px;\n  border-radius: 10px;\n  width: 30px;\n  height: 35px;\n  margin: 10px 5px;\n  background-color: #f1f1f1;\n  font-size: 16px;\n  font-family: \"Acumin-RPro\", sans-serif;\n  border: none;\n  text-align: center;\n}\n\n.code-input:focus {\n  outline: 2px solid #ff2a2f;\n}\n\n.error {\n  color: #ff2a2f;\n  font-size: 12px;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.error-container {\n  margin-top: -20px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.error-container2 {\n  margin-top: -20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-direction: column;\n}\n\n.resend-code {\n  font-size: 14px;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Acumin-RPro\", sans-serif;\n  text-decoration: underline;\n}\n\n.resend-refresh {\n  font-size: 14px;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.title-gender {\n  margin-bottom: 20px;\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 20px;\n}\n\n.description-text {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 10px;\n  text-align: left;\n  padding-left: 10px;\n  color: #808080;\n}\n\n.gender-description-text {\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 10px;\n  text-align: left;\n  padding-left: 5px;\n  color: #808080;\n}\n\n.gender-input-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  border-radius: 8px;\n  background: #f1f1f1;\n\n  margin-left: 0.5rem;\n  cursor: pointer;\n  padding: 9px 12px 9px 12px;\n}\n\n.gender-input-container label {\n  width: 100%;\n  text-align: left;\n  margin-right: auto;\n  cursor: pointer;\n  align-items: center;\n}\n\n.gender-input-container input[type=\"radio\"] {\n  accent-color: #ff2a2f;\n}\n\n.gender-input-container:focus-within {\n  outline: 2px solid #808080;\n}\n.date-input-container {\n  position: relative; /* Allows absolute positioning inside */\n  width: 100%; /* Adjust as needed */\n  max-width: 300px; /* Adjust as needed */\n}\n\n/* Style for the input field */\n.date-input-field {\n  padding: 10px;\n  border-radius: 10px;\n  width: 300px;\n  height: 45px;\n  margin-top: -60px;\n  margin-bottom: 0px;\n  padding-right: 30px;\n  border: none;\n  background-color: #f1f1f1;\n  font-size: 20px;\n  font-family: \"Acumin-RPro\", sans-serif;\n  color: #000;\n  text-align: left;\n}\n\n.date-input-icon {\n  position: absolute;\n  top: 15px;\n  right: 10px; /* Adjust as needed */\n  transform: translateY(-50%); /* Centers the icon vertically */\n  height: 20px; /* Adjust as needed */\n  width: 20px; /* Adjust as needed */\n  pointer-events: none; /* Makes the icon non-interactive */\n}\n\n.date-error-container {\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.select-interests-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.select-interest-button {\n  padding: 10px;\n  border-radius: 30px;\n  width: 45%;\n  margin: 5px;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pink-background {\n  background-color: #f6dada;\n  color: #000000;\n  border: none;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.normal-background {\n  background-color: #f2f2f2;\n  color: #000000;\n  pointer-events: auto;\n  user-select: none;\n  outline: none;\n  border: none;\n  font-family: \"Acumin-RPro\", sans-serif;\n}\n\n.interest-description-text {\n  font-size: 16px;\n  text-align: center;\n  color: #393939;\n}\n\n.interests-button-container {\n  display: flex;\n  justify-content: center;\n}\n\n.columns-interests {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.title-interests {\n  text-align: center;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 20px;\n}\n\n.profile-upload-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.ProfilePicture_Sub-Text {\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto 10px;\n  text-align: center;\n  padding-left: 10px;\n  color: #808080;\n  font-size: small;\n}\n\n.image-box {\n  width: 150px;\n  height: 150px;\n  border-radius: 10px;\n  background-color: #eaeaea;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-bottom: 20px;\n}\n\n.upload-box {\n  display: flex;\n  align-items: center; /* Vertical alignment */\n  justify-content: center; /* Horizontal alignment */\n  width: 150px; /* Same width as image-box */\n  height: 150px; /* Same height as image-box */\n  border-radius: 10px; /* Same border radius as image-box */\n  background-color: #eaeaea; /* Same background color as image-box */\n  margin-bottom: 20px; /* Same bottom margin as image-box */\n  color: #666; /* Text color, can be adjusted */\n  font-size: 14px; /* Text size, can be adjusted */\n  cursor: pointer; /* Changes the cursor to indicate it's clickable */\n  text-align: center; /* Ensures text is centered */\n}\n\n.image-box2 {\n  width: 250px;\n  height: 250px;\n  border-radius: 20px;\n  background-color: #eaeaea;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin-bottom: 10px;\n}\n\n.upload-box2 {\n  display: flex;\n  align-items: center; /* Vertical alignment */\n  justify-content: center; /* Horizontal alignment */\n  width: 250px; /* Same width as image-box */\n  height: 250px; /* Same height as image-box */\n  border-radius: 20px; /* Same border radius as image-box */\n  background-color: #eaeaea; /* Same background color as image-box */\n  margin-bottom: 10px; /* Same bottom margin as image-box */\n  color: #666; /* Text color, can be adjusted */\n  font-size: 14px; /* Text size, can be adjusted */\n  cursor: pointer; /* Changes the cursor to indicate it's clickable */\n  text-align: center; /* Ensures text is centered */\n}\n\n.Optional {\n  width: 100%;\n  max-width: 300px;\n  text-align: center;\n  color: #808080;\n  font-size: small;\n  margin-bottom: -5rem;\n}\n\n.profile-image {\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.file-input {\n  display: none;\n}\n\n.signup2-container {\n  font-family: \"Acumin-RPro\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Centers items horizontally */\n  height: 100vh; /* Full height of the viewport */\n  padding: 20px; /* Adds some padding around the container */\n}\n\n.paypal-vemo-logo {\n  width: 32px;\n}\n\n.payment-button-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.payment-button {\n  display: flex;\n  width: 371px;\n  padding: 10px 20px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 16px;\n  margin: 10px 0;\n  font-size: 20px;\n  border: none;\n  cursor: pointer;\n  background-color: rgba(241, 241, 241, 0.658);\n  color: #000000;\n  font-family: \"Acumin-RPro\", sans-serif;\n  transition: background-color 0.3s;\n}\n\n.payment-button-hovered {\n  background-color: rgba(208, 208, 208, 0.658);\n}\n\n.footer-content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: auto;\n}\n\n.termstitle {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5vh;\n}\n\n.Terms {\n  display: flex;\n  flex-direction: column;\n  margin-left: 0rem;\n  align-items: start;\n}\n\n.title-verification3 {\n  text-decoration: none;\n  color: black;\n  margin-top: -10px;\n  text-align: left;\n  font-family: \"Acumin-BdPro\", sans-serif;\n  font-size: 20px;\n  margin-left: 0.2rem;\n  align-self: first baseline;\n}\n\n.custom-link {\n  color: #ff2a2f;\n  text-decoration: none;\n}\n\n#custom-link:hover {\n  text-decoration: underline;\n}\n\n.Conditions {\n  margin-top: -rem;\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n}\n\n.Condition {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 3rem;\n}\n\n.Condition label {\n  text-align: left;\n  font-size: larger;\n}\n\n.Message {\n  margin-left: 5rem;\n  margin-top: -2.5rem;\n}\n\n.Conditions input[type=\"checkbox\"] {\n  display: none;\n}\n\n.custom-checkbox {\n  width: 40px;\n  height: 40px;\n  background-color: #eee;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\ninput[type=\"checkbox\"]:checked + .custom-checkbox::before {\n  content: \"\\2713\";\n}\n\ninput[type=\"checkbox\"]:checked + .custom-checkbox {\n  background-color: #ff2a2f;\n  content: \"\\2713\";\n  color: black;\n}\n\n.footer-logo img {\n  margin-left: 4px;\n  height: 40px; /* Adjust as per your logo's dimensions */\n}\n\n.quiz-container {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.quiz-container p {\n  margin-bottom: 10px;\n}\n\n.quiz-container strong {\n  font-weight: bold;\n  color: #333;\n}\n\n.quiz-container p strong {\n  margin-right: 5px;\n}\n\n.quiz-container p:last-child {\n  margin-bottom: 0;\n}\n\n.quiz-container-ol {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.quiz-container-ol-choice:hover {\n  /* Your styles for hover state */\n  background-color: #f0f0f0;\n  transition: ease-in-out 0.2s;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 200px) {\n  .fixed-footer {\n    /* Mobile-specific styles here */\n  }\n\n  .footer-content {\n    flex-direction: column;\n  }\n}\n\n.USA-HEADER {\n  width: 280px;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n.asset-brandName {\n  margin-left: 5px;\n  color: blue;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
